import { render, staticRenderFns } from "./StudentInvitationCard.vue?vue&type=template&id=49588a22&scoped=true"
import script from "./StudentInvitationCard.vue?vue&type=script&lang=js"
export * from "./StudentInvitationCard.vue?vue&type=script&lang=js"
import style0 from "./StudentInvitationCard.vue?vue&type=style&index=0&id=49588a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49588a22",
  null
  
)

export default component.exports